import Notificacion from '../../Modal.vue'

function Install (Vue, options) {
  const property = (options && options.property) || '$notificacion'
  function createDialogCmp (options) {
    return new Promise(resolve => {
      const cmp = new Vue(Object.assign({}, Notificacion, {
        propsData: Object.assign({}, Vue.prototype.$notificacion.options, options),
        destroyed: () => {
          document.body.removeChild(cmp.$el)
          resolve(cmp.value)
        }
      }))
      document.body.appendChild(cmp.$mount().$el)
    })
  }
  
  function show (message, options = {}) {
    options.message = message
    return createDialogCmp(options)
  }

  Vue.prototype[property] = show
  Vue.prototype[property].options = options || {}
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Install)
}

export default Install
